export enum AsyncRules {
    // Return true if the assignment feature is active, current user allowed and, if lesson is passed, passed lesson is allowed
    AssignLesson = 'assignment.assign-lesson',
    // If true, the user can access to assignments (todo add rules to be specific (all assignments, class assignments, own assignments, etc.))
    ReadAssignments = 'assignment.read-assignment',
    IsUserHasTrainerRight = 'assignment.is-user-has-trainer-right',
}
